import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    root: {
        borderTop: '1px solid rgba(55, 55, 55, 0.44)', 
        width: 'calc(100% - 30px)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        margin: '0 auto', 
        padding: '15px 15px 15px'
    },
    wrapLeft: {
        display: 'flex', 
        flexDirection: 'column'
    },
    text: {
        color: '#7C5B8D', 
        fontWeight: 'normal', 
        fontSize: 16, 
        fontFamily: 'Circe, sans-serif'
    },
    wrapRight: {
        width: 42, 
        height: 42, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: 'rgba(255, 255, 255, 0.07)', 
        backgroundBlendMode: 'soft-light, normal', 
        backdropFilter: 'blur(9px)', 
        borderRadius: 13
    },
    text18: {
        color: '#FFFFFF', 
        fontWeight: 'normal', 
        fontSize: 16, 
        fontFamily: 'Circe, sans-serif'
    }
}))